<template>
  <b-modal
    v-if="wikiStore.isOpen"
    ref="wikiDetails"
    hide-footer
    :model-value="wikiStore.isOpen"
    size="lg"
    scrollable
    @hidden="_close">
    <template #header>
      <div class="d-flex flex-row justify-content-between w-100">
        <div class="float-start d-flex flex-row">
          <div class="wiki-permalink">
            <b-button
              @click="wikiStore.showArticle('levumipedia')"
              variant="outline-primary"
              class="me-3">
              <i class="fas fa-home"></i>
            </b-button>
          </div>
          <div v-if="showBackButton" class="wiki-permalink">
            <b-button @click="wikiStore.navigateBack" variant="outline-primary" class="me-3">
              <i class="fas fa-arrow-left"></i>
            </b-button>
          </div>
          <div v-else></div>
        </div>
        <div class="fs-4">
          <strong>{{ wikiStore.displayedArticle.title }}</strong>
        </div>
        <div></div>
      </div>
    </template>
    <div class="text-break wiki-body" v-html="parsedContent" @click="handleClick($event)"></div>
    <div v-if="showRelatedArticles" class="wiki-body">
      <hr />
      <strong>Weiterführende Artikel</strong>
      <ul>
        <li v-for="link in relatedArticles">
          <a :href="'#' + link.perma_link" @click="handleClick">{{ link.title }}</a>
        </li>
      </ul>
    </div>
    <div class="d-flex justify-content-end">
      <b-button variant="outline-success" class="m-1" @click="_close">Ok</b-button>
    </div>
  </b-modal>
</template>
<script setup>
  import { ref, computed } from 'vue'
  import { useWikiStore } from 'src/store/wikiStore'
  import { useRouter } from 'vue-router'
  const wikiStore = useWikiStore()
  const router = useRouter()

  const wikiDetails = ref()

  const showRelatedArticles = computed(
    () =>
      wikiStore.displayedArticle.wiki_tags.map(tag => tag.name).includes('Allgemein') &&
      wikiStore.displayedArticle.wiki_tags.length > 1
  )

  const relatedArticles = computed(() => {
    const currentRelevantTag = wikiStore.displayedArticle.wiki_tags
      .filter(tag => tag.name !== 'FAQ' && tag.name !== 'Allgemein')
      .map(t => t.name)[0]
    const related = wikiStore.articles.filter(article => {
      const tagNames = article.wiki_tags.map(t => t.name)
      return tagNames.includes(currentRelevantTag) && tagNames.includes('FAQ')
    })
    return related
  })

  const showBackButton = computed(() => {
    return wikiStore.history.length > 1
  })

  const parsedContent = computed(() => {
    const content = wikiStore.displayedArticle.content
    const pathMapping = wikiStore.displayedArticle.wiki_images
    return content.replace(
      /<img\s+([^>]*?)src=(["'])(.*?)\2/gi,
      (match, beforeSrc, quote, oldSrc) => {
        const newSrc = pathMapping[oldSrc]
        if (newSrc) {
          return `<img ${beforeSrc}src=${quote}${newSrc}${quote}`
        }
        return match
      }
    )
  })

  const handleClick = event => {
    if (event.target.tagName.toLowerCase() === 'a' && !event.target.dataset.external) {
      event.preventDefault()
      const link = event.target.href.split('#')
      if (link[1]) {
        wikiStore.showArticle(link[1])
      } else {
        const url = new URL(event.target.href)
        router.push(url.pathname)
      }
    }
  }

  const _close = () => {
    wikiStore.resetDisplayedArticle()
  }
</script>
<style>
  .wiki-permalink {
    font-weight: bold;
  }
  .wiki-body a {
    text-decoration: underline;
    font-weight: bold;
  }
</style>
